var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4516 4.58786H17.4903V3.96429C17.4903 3.43714 17.0581 3 16.5226 3C15.9871 3 15.5548 3.43714 15.5548 3.96429V4.58786H12.9677V3.96429C12.9677 3.43714 12.5355 3 12 3C11.4645 3 11.0323 3.43714 11.0323 3.96429V4.58786H8.44516V3.96429C8.44516 3.43714 8.0129 3 7.47742 3C6.94194 3 6.50968 3.43714 6.50968 3.96429V4.58786H5.54839C3.59355 4.58786 2 6.16929 2 8.12357V17.4643C2 19.4121 3.59355 21 5.54839 21H18.4516C20.4065 21 22 19.4121 22 17.4643V8.12357C22 6.16929 20.4065 4.58786 18.4516 4.58786ZM20.0645 9.18429H3.93548V8.12357C3.93548 7.69733 4.10541 7.28855 4.40789 6.98715C4.71037 6.68575 5.12062 6.51643 5.54839 6.51643H6.50968V7.10143C6.50968 7.635 6.94194 8.06571 7.47742 8.06571C8.0129 8.06571 8.44516 7.635 8.44516 7.10143V6.51643H11.0323V7.10143C11.0323 7.635 11.4645 8.06571 12 8.06571C12.5355 8.06571 12.9677 7.635 12.9677 7.10143V6.51643H15.5548V7.10143C15.5548 7.635 15.9871 8.06571 16.5226 8.06571C17.0581 8.06571 17.4903 7.635 17.4903 7.10143V6.51643H18.4516C18.8794 6.51643 19.2896 6.68575 19.5921 6.98715C19.8946 7.28855 20.0645 7.69733 20.0645 8.12357V9.18429Z",
    fill: "url(#paint0_linear_3095_1757)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3095_1757",
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWhite);
export default __webpack_public_path__ + "static/media/calendar-white.48646ecd6695a57dc888f69cf11d9aee.svg";
export { ForwardRef as ReactComponent };